<template>
  <div>
    <base-header class="pb-6" />

    <b-container fluid class="mt--6 max-width">
      <b-card no-body>
        <card-header title="Entities">
          <base-button size="sm" @click="onNewEntity">Add Entity</base-button>
        </card-header>

        <el-table header-row-class-name="thead-light" :data="entities">
          <template #empty
            ><span v-if="loading"
              >Loading Entites
              <i class="fas fa-sync-alt fa-spin mr-1"></i></span
            ><span v-else>No Entities Found</span></template
          >
          <el-table-column
            class-name="font-weight-bold"
            label="Name"
            sortable
            prop="name"
          />
          <el-table-column label="Description" sortable prop="description" />

          <el-table-column>
            <div slot-scope="{ row }" label="Actions" class="table-actions">
              <!-- Edit Button -->
              <!-- This section is Licence -->
              <base-button
                @click.native="onEdit(row)"
                class="remove btn-link"
                type=""
                size="sm"
                icon
              >
                <i class="text-dark fas fa-edit"></i>
              </base-button>
              <!-- End of new section -->

              <base-button
                @click.native="onDelete(row)"
                class="remove btn-link"
                type="danger"
                size="sm"
                icon
              >
                <i class="text-white fas fa-trash"></i>
              </base-button>
            </div>
          </el-table-column>
        </el-table>
      </b-card>
    </b-container>
  </div>
</template>

<!-- ###################################################################### -->

<script>
import { mapState } from "vuex";
import { Action } from "@/store/actions";
import { Routes } from "@/router";
import { Table, TableColumn, Tooltip } from "element-ui";
import CardHeader from "@/views/components/CardHeader";
import { confirmDelete } from "@/helper";

export default {
  name: "EntityList",
  components: {
    CardHeader,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    loadEntities() {
      this.loading = true;
      this.$store
        .dispatch(Action.landlord.loadEntitiesSpecific,"basic",null)
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          console.error("Failed to load Entites:", error);
          this.loading = false;
        });
    },
    onNewEntity() {
      this.$router.push({ name: Routes.entityNew });
    },
    onEdit(row) {
      // This method is new and not present in the first code
      // Navigate to the edit page with the selected entity's name
      this.$router.push({
        name: Routes.entityEdit,
        params: { entityName: row.name },
      });
    },
    onDelete(row) {
      confirmDelete().then((result) => {
        if (result.value) {
          this.$store.dispatch(Action.landlord.deleteEntity, row);
        }
      });
    },
  },
  computed: {
    ...mapState({
      entities: (state) => state.landlord.entities,

      loading: (state) => state.general.loading,
    }),
  },
  mounted() {
    this.loadEntities();
  },
};
</script>
